import React, { FC } from "react";
import ResetPasswordForm from "@components/ResetPasswordForm/ResetPasswordForm";
import SideImageLayout from "@components/SideImageLayout/SideImageLayout";

const ResetPassword: FC = () => {
  return (
    <SideImageLayout>
      <ResetPasswordForm />
    </SideImageLayout>
  );
};

export default ResetPassword;
